const mTheHeaderLimitDate = {
  mTheHeaderLimitDate: {
    upgrade: {
      firstText: 'Te quedan ',
      secondText: ' días',
      thirdText: ' de tu prueba gratis de Vidroop',
      forcedUpgradeText: 'Tu prueba gratis ha finalizado',
      firstLinkText: '> Si quiero mi ',
      secondLinkText: 'DESCUENTO ESPECIAL',
      thirdLinkText: ' de Vidroop Inicia'
    }
  }
}

export default mTheHeaderLimitDate
